import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { SensitiveData } from '~/shared-components';
import Avatar from '@bufferapp/ui/Avatar';
import { Text } from '@bufferapp/ui';

const AvatarContainer = styled.div`
  display: flex;
  padding: 8px 0px 5px;
`;

const AvatarNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 16px;
`;

const HeaderBar = () => {
  const selectedProfile = useSelector(
    (state) => state.profileSidebar.selectedProfile
  );

  return (
    <>
      <AvatarContainer>
        <Avatar
          src={selectedProfile.avatar_https}
          fallbackUrl="https://s3.amazonaws.com/buffer-ui/Default+Avatar.png"
          alt={selectedProfile.handle}
          size="medium"
          type="social"
          network={selectedProfile.service}
        />
        <AvatarNameWrapper>
          <SensitiveData>
            <Text type="p">{selectedProfile.handle}</Text>
          </SensitiveData>
        </AvatarNameWrapper>
      </AvatarContainer>
    </>
  );
};

export default HeaderBar;
